import singleExerciseModule from "@/store/modules/single-exercise.module";
import Vue from "vue";
import Component from "vue-class-component";

@Component({})
export default class musclesViewComponent extends Vue {
    private frontView = true

    get frontViewState() {
        return this.frontView
    }

    switchView() {
        this.frontView = !this.frontView

    }

    clickedPart(e: any) {
        const bodyPart = e.target.dataset.region as any
        if (bodyPart) {
            singleExerciseModule.addFilter('muscleGroup-' + bodyPart)
        }
    }

    isActive(bodyPart: string) {
        const partIdx = singleExerciseModule.activeFilters.findIndex((muscleGroup: string) => muscleGroup === 'muscleGroup-' + bodyPart)
        return partIdx >= 0 ? true : false
    }
}